import { Loader } from './loader';
import axios from 'axios';


export class AxiosConfig {

    /**
     * @param {boolean | undefined} exibirLoader
     */
    constructor(exibirLoader) {
        this._axios  = axios.create();
        this._loader = Loader;

        this._interceptors(exibirLoader);
    }

    instanciaAxios() {
        return this._axios;
    }

     /**
     * Adicona um loader no inicio de cada requisição e remove o mesmo no final da requisição.
     * @param {boolean} exibirLoader
     */
     _interceptors(exibirLoader) {
        if (exibirLoader === false) {
            return;
        }

        this._axios.interceptors.request.use(
            (config) => {
                this._loader.ativarLoader();
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

         this._axios.interceptors.response.use(
             (response) => {
                 this._loader.ativarLoader();
                 return response;
             },
             (error) => {
                 return Promise.reject(error);
             },
         );
    }
}
